import { createFileRoute } from '@tanstack/react-router'
import { TaxExemptionsPage } from '@/features/tax-exemptions/tax-exemptions-page'

export const Route = createFileRoute('/_authenticated/tax-exemptions/')({
  staticData: { title: 'Tax exemptions' },
  component: TaxExemptionsPage,
})
